<template>
  <div class="flip-container" :class="flipped ? 'flipped' : ''" :style="style">
    <div class="flipper">
      <div class="front" style="width:100%">
        <slot name="front" @flip="flipped = true"></slot>
      </div>
      <div class="back" style="width:100%">
        <slot name="back" @flip="flipped = false"></slot>
      </div>
    </div>
  </div>
</template>
<style>
/* entire container, keeps perspective */
.flip-container {
  perspective: 2000px;
  background: transparent;
}
/* flip the pane when hovered */
.flip-container.flipped .flipper, .flip-container.flipped .flipper {
  transform: rotateY(180deg);
}

/* .flip-container, .front, .back {
  width: var(--width);
  height: var(--height);
} */

/* flip speed goes here */
.flipper {
  transition: 0.6s;
  transform-style: preserve-3d;

  position: relative;
  background: transparent;
}

/* hide back of pane during swap */
.front, .back {
  backface-visibility: hidden;

  position: absolute;
  top: 0;
  left: 0;
  margin: 0 auto;
}

/* front pane, placed above back */
.front {
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}

/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);
}
</style>
<script>
import { computed } from '@vue/composition-api'
export default {
  props: {
    flipped: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 400
    }
  },
  setup (props) {
    const style = computed(() => 'width:' + props.width + 'px;height:' + props.height + 'px')

    return {
      style
    }
  }
}
</script>
